import { ReactNode, useEffect, useRef, useState } from 'react';
// @ts-expect-error TS(2305): Module '"styled-system"' has no exported member 'P... Remove this comment to see the full error message
import { Props as StyleProps } from 'styled-system';

import { Box } from 'components/Box';

function FixedSpacerContainer({
  children,
  ...props
}: StyleProps & {
  children: ReactNode;
}) {
  const ref = useRef(null);
  const [height, setHeight] = useState('auto');
  useEffect(() => {
    const update = () => {
      // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
      if (ref && ref.current) {
        // @ts-expect-error TS(2339): Property 'offsetHeight' does not exist on type 'ne... Remove this comment to see the full error message
        setHeight(ref.current.offsetHeight || 'auto');
      }
    };

    update();

    if (window) {
      window.addEventListener('resize', update);
      return window.addEventListener('resize', update);
    }
  }, [children]);
  return (
    <Box height={height}>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <Box position="fixed" {...props}>
        <div ref={ref}>{children}</div>
      </Box>
    </Box>
  );
}

// eslint-disable-next-line import/no-default-export
export default FixedSpacerContainer;
